import React, { useEffect, useState } from 'react';
import { MasterDataGrid } from "@/components/";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import FinancialError from './financial-error';

interface IFinancialResults{
    result: any;
    screen: string;
    columns: any[];
    saveTable: any;
    summary: any;
    idx: number;
    status: any;
    tableAlert: string;
    dataColumns: any;
    initialValidate: boolean;
    section: string;
    year: number;
}

const FinancialResults: React.FC<IFinancialResults> = ({result, screen, columns, saveTable, tableAlert, summary, idx, status, dataColumns, initialValidate, section, year}: IFinancialResults) => {
    const [auxData, setAuxData] = useState(null);
    const view: IFollowupSubproject = {
        state: {
            dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    const changeStyles = (parentGrid: any) => {
        if(parentGrid !== undefined){
            const element = parentGrid.element();
            const totals = element.querySelector(".dx-datagrid-total-footer div:last-child tbody tr") as HTMLElement;
            const totalHeader = element.querySelector(".dx-datagrid-total-footer table tbody tr") as HTMLElement;

            if(totals !== null){
                totals.childNodes.forEach((childNode: any) => {
                    childNode.style.borderColor = "rgba(0,0,0,0.1)";
                    childNode.style.backgroundColor = "rgba(255,240,230,0.8)";
                })
            }
            if(totalHeader !== null){
                totalHeader.childNodes.forEach((childNode: any) => {
                    childNode.style.borderColor = "rgba(0,0,0,0.1)";
                    childNode.style.backgroundColor = "rgba(255,240,230,0.8)";
                })
            }
        }
    }


    useEffect(() => {
        if((tableAlert === `${result.id}-actResult` || !tableAlert || tableAlert === 'All') && result?.data && columns) {
			let asd = getAuxData()
            setAuxData(asd)
        }
    }, [result?.data, tableAlert, columns, initialValidate]); 

    const getAuxData = () => {

        /* const getDataSource = () => {
            
            let data = [...result.data].filter((item: any) => item.currentBudget !== null)

            if(year >= 2023){
                let groupedActivities = false 
                data.forEach((act: any) => {
                    if(!!act.currentBudget) groupedActivities = true
                })

                if(groupedActivities) return data.filter((obj : any) => obj.currentBudget)
                else return data
            }

            return result.data
        } */

		return (
            <>
                <FinancialError 
                    section={section}
                    initialValidate={initialValidate}
                    checkFinancialValues={(item: any) => presenter.checkFinancialValues(item, status, section)}
                    msgInitialError={presenter.followupLabels.get("completeActInfo")}
                    followupLabels={presenter.followupLabels}
                    tableAlert={tableAlert}
                    calculatedSumMonth={(item: any) => presenter.checkSumMonth(item, status?.CodigoDimension)} 
                    calculatedReqFields={(item: any) => presenter.checkReqFields(item, status)} 
                    gridId={`${result.id}-actResult`} 
                    changeStyles={changeStyles}
                />
                <MasterDataGrid 
                    id={`${result.id}-actResult`}
                    dataSource={result.data} // .filter((obj : any) => obj.totalBudget)
                    columns={columns.filter((col: any) => col.dataField !== "result")}
                    allowCode={screen}
                    saveTable={saveTable}
                    gridTitle={presenter.followupLabels.get("financialExpectedResultTitle")}
                    gridHelpId={`tooltip-${result.id}-actResult`}
                    gridHelpText={presenter.followupLabels.get("helpFinancialExpectedResult")}
                    gridProps={{
                        width: "100%",
                        scrolling:{mode: "standard" , rowRenderingMode: "standard"},
                        editing:{ mode: "batch", allowUpdating: true, allowAdding: false, allowDeleting: false},
                        selection:{
                            mode:"single"
                        },
                        summary: {
                            recalculateWhileEditing: true,
                            totalItems: summary.totalItems,
                            calculateCustomSummary: (options) => summary.calculateCustomSummary(options, idx)
                        },
                    }}
                />
            </>
        )
    }

    return (
        <>
            {auxData && auxData}
        </>
    )
}

export default FinancialResults;